/**
 * Created by stonewang on 2017/8/17.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Upload, message, Button } from 'antd';
import {config} from 'Utils';


class UploadFile extends React.Component {
  render () {
    const self = this;
    const {color, text, entityType, entityId} = this.props;
    const uploadProps = {
      name: 'file',
      //accept: 'application/vnd.ms-excel',
      action: `${config.server}/api/v1/dms/commonAttachUpload/mongoUpload`,
      /*headers: {
        authorization: 'authorization-text',
      },*/
      data: (file)=>{
        let dealType = '';
        switch (entityType){//1-渠道；2-渠道联系人；3-门店；4-门店店员；5-经销商回款；6-经销商应付 
          case 'channel':
            dealType = 1;
            break;
          case 'linkman':
            dealType= 2;
            break;
          case 'store':
            dealType = 3;
            break;
          case 'staff':
            dealType = 4;
            break;
          case 'payment':
            dealType = 5;
            break;
          case 'payable':
            dealType = 6;
            break;
          default:
            break;
        }
        if(!dealType){
          message.error('entityType是一个无效的值');
        }
        return {
          id: entityId,
          dealType,
        }
      },
      /*beforeUpload: (file, fileList) => {
        let ext = file.name.split('.');
        if (ext[ext.length - 1] === 'xls') {
          return true;
        } else {
          message.error('只支持上传xls格式的excel文件', 3);
          return false;
        }
      },*/
      onChange(info) {
        if (info.file.status !== 'uploading') {
          console.log(info.file, info.fileList);
        }
        if (info.file.status === 'done') {
          if (info.file.response.status) {
            message.success(info.file.response.message, 3);
            if(self.props.onSuccess){
              self.props.onSuccess();
            }
          } else {
            message.error(info.file.response.message, 3);
          }
        } else if (info.file.status === 'error') {
          message.error('上传文件失败');
        }
      },
      showUploadList: false,
    };
    if(color && color=== 'red'){
      return <Upload {...uploadProps}>
        <Button type="primary">{text||'上传附件'}</Button>
      </Upload>
    }else{
      return <Upload {...uploadProps}>
        <Button icon="upload">{text||'上传附件'}</Button>
      </Upload>
    }
  }
}
UploadFile.propTypes = {
  entityId: PropTypes.any.isRequired,
  entityType: PropTypes.string.isRequired,
  onSuccess: PropTypes.func,
  color: PropTypes.string,
  text: PropTypes.string
};
export default UploadFile;


// WEBPACK FOOTER //
// ./src/components/uploadFile.js